// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__uU-Zo","ranges":"BmiRanges_ranges__3i6cT"};